import { showNotificationGlobal } from "stores/useNotificationStore";

export function copyToClipboard(
  text: string,
  copied: string,
  failed: string,
): void {
  navigator.clipboard
    .writeText(text)
    .then(() => showNotificationGlobal(copied, "success"))
    .catch(() => showNotificationGlobal(failed, "error"));
}

export const copyTableId = (tableId: string): void =>
  copyToClipboard(tableId, "Table ID copied", "Couldn't copy the table id");

export const copyModelId = (modelId: string): void =>
  copyToClipboard(
    modelId,
    "Model ID copied to clipboard",
    "Couldn't copy the model ID",
  );
